import React from "react";
import DetailsCard from "./DetailsCard";

const UserDetails = ({
  userData,
  onAssignUser,
  onAssignDepartment,
  onAssignLocation,
  canAssignLocation,
}) => {
  // User details object - using the same fields as the table
  const details = {
    Name: userData?.callUserLines?.[0]?.name || "--",
    "Primary phone number": userData?.callUserLines?.[0]?.callPhoneNumber?.phoneNumber || "--",
    "Primary extension": userData?.callUserLines?.[0]?.callExtension?.number || "--",
    "EAI user": userData?.user?.fullName || null,
    Department: userData?.departmentLevel || null,
    ...(canAssignLocation && { Location: userData?.originalLocation?.title || null }),
  };

  const handleEdit = fieldKey => {
    if (fieldKey === "EAI user") {
      if (onAssignUser) onAssignUser();
    } else if (fieldKey === "Department") {
      if (onAssignDepartment) onAssignDepartment();
    } else if (fieldKey === "Location") {
      if (onAssignLocation) onAssignLocation();
    }
  };

  return (
    <div className="mb-4">
      {/* User details using DetailsCard */}
      <DetailsCard
        title="Details"
        details={details}
        editableFields={["EAI user", "Department", "Location"]}
        onEdit={handleEdit}
      />
    </div>
  );
};

export default UserDetails;
